import { IGameState } from 'State/Game/IGameState';

export enum AdDebugMode {
    DEFAULT = 'default',
    FAIL_IMMEDIATE = 'fail_immediate',
    SUCCESS_IMMEDIATE = 'success_immediate',
}

export function SetAdDebugMode(state: IGameState, mode: AdDebugMode): IGameState {
    switch (mode) {
        case AdDebugMode.DEFAULT:
        case AdDebugMode.FAIL_IMMEDIATE:
        case AdDebugMode.SUCCESS_IMMEDIATE:
            return {
                ...state,
                perSessionData : {
                    ...state.perSessionData,
                    adDebugMode: mode,
                }

            };
        default:
            console.log(
                `Error: Please specify valid ad debug mode: ${[
                    AdDebugMode.DEFAULT,
                    AdDebugMode.FAIL_IMMEDIATE,
                    AdDebugMode.SUCCESS_IMMEDIATE,
                ].join(', ')}`
            );
    }

    // Should not get here.
    return state;
}
